module.exports = __webpack_public_path__ + "static/media/notification-error.c8ecb5ff.svg";